import { DTO } from "./dto.js";

export class AlumnoDTO extends DTO {
    constructor() {
        super();
        this.nombres = "";
        this.apellidos = "";
        this.dni = 0;
        this.cohorte = 0;
        this.lf = "";
        this.carreras = [];
    }

    cargarDTO(dto) {
        super.cargarDTO(dto);

        if (dto.nombres !== undefined) { this.nombres = dto.nombres; }
        if (dto.apellidos !== undefined) { this.apellidos = dto.apellidos; }
        if (dto.dni !== undefined) { this.dni = dto.dni; }
        if (dto.cohorte !== undefined) { this.cohorte = dto.cohorte; }
        if (dto.lf !== undefined) { this.lf = dto.lf; }
        if (dto.carreras !== undefined) { this.carreras = dto.carreras; }
    }

    clone(dto) {
        super.clone(dto);

        dto.nombres = this.nombres;
        dto.apellidos = this.apellidos;
        dto.dni = this.dni;
        dto.cohorte = this.cohorte;
        dto.lf = this.lf;
        dto.carreras = this.carreras;
    }
}
